<template>
  <div>
    <el-card>
      <el-row>
        <el-col class="flex-items">
          <toolbar
            :buttonList="buttonList"
            @callFunction="callFunction"
          ></toolbar>
          <el-button type="goon" @click="onAddFood">新增菜肴</el-button>

          <el-button type="goon" @click="resetSearch" v-if="buttonList"
            >清空</el-button
          >
        </el-col>
      </el-row>
    </el-card>
    <!-- <el-card style="margin-top: 20px">
      <el-button type="goon" @click="onAddFood">新增菜肴</el-button>
    </el-card> -->
    <el-card style="margin-top: 20px">
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
          'text-align': 'center',
        }"
        @current-change="selectCurrentRow"
      >
        <el-table-column prop="Id" label="序号" width="100" align="center">
        </el-table-column>
        <el-table-column
          prop="DishName"
          label="菜肴名称"
          width="200"
          align="center"
        >
        </el-table-column>
        <el-table-column label="食材" align="center">
          <template slot-scope="scope">
            <div class="flex-items">
              <div
                v-for="(item, index) in scope.row.List"
                :key="index"
                style="padding-left: 15px"
              >
                {{ item.FoodName }}
                {{ item.Weight == 0 ? "" : item.Weight + "g" }}
              </div>
            </div>
          </template>
        </el-table-column>

        <!-- <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="onClickEditData(scope.row)"
              >编辑</el-button
            ><el-button
              type="text"
              style="color: '#E14747'"
              @click="handledel(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="PageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center;padding:20px; 0 0 0"
      >
      </el-pagination>
    </el-card>
    <el-dialog :title="Title" :visible.sync="dialogVisible" width="50%">
      <div>
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          class="demo-ruleForm"
          label-position="left"
          label-width="100px"
        >
          <el-form-item label="菜肴名称：">
            <el-input
              placeholder="请输入菜肴名称"
              v-model="ruleForm.dishName"
            ></el-input>
          </el-form-item>

          <el-form-item label="食材：">
            <el-row>
              <el-col :span="6" class="mg-right">
                <el-autocomplete
                  style="width: 100%"
                  v-model="ruleForm.ingredientValue"
                  :fetch-suggestions="querySearchAsync"
                  :trigger-on-focus="false"
                  placeholder="请输入食材关键字"
                  @select="handleSelect"
                ></el-autocomplete>
                <!-- <el-input placeholder="请输入食材关键字"></el-input> -->
              </el-col>
              <el-col :span="6" class="mg-right flex-items">
                <el-input
                  placeholder="请输入食材重量"
                  type="number"
                  v-model="ruleForm.weight"
                ></el-input>
                <div style="font-size: 16px; color: #333; padding-left: 5px">
                  g
                </div>
              </el-col>

              <el-col :span="5">
                <el-button type="goon" v-if="isActive" @click="onClickFood"
                  >添加</el-button
                >
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="已添加食材：">
            <el-row
              class="mg-bottom"
              v-for="(item, index) in foodJson"
              :key="index"
            >
              <el-col :span="6" class="mg-right">
                <div class="tui-food">{{ item.value }}</div>
              </el-col>
              <el-col :span="6" class="mg-right">
                <div class="tui-food">{{ item.weight }}</div>
              </el-col>

              <el-col :span="5">
                <el-button type="danger" @click="onClickDelete(index)"
                  >删除</el-button
                >
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="goon"
          @click="
            Title == '新增菜肴' ? addSubmit('ruleForm') : editSubmit('ruleForm')
          "
          >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetFoodDishList,
  AddHe_FoodDish,
  GetFoodLibrary,
  DelHe_FoodDish,
  UpdateHe_FoodDish,
} from "../../../api/api";
import { getButtonList } from "@/promissionRouter";
import Toolbar from "@/components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      tableData: [],
      PageSize: 10,
      PageIndex: 1,
      total: 0,
      dialogVisible: false,
      Title: "",
      indexInfo: {
        date: "",
      },
      ruleForm: {
        Id: "",
        dishName: "",
        ingredientValue: "",
        weight: "",
      },
      Name: "",
      userInfo: {},
      isActive: false,
      foodJson: [],
      foodId: 0,
      buttonList: [],
      filters: {
        Name: "",
      },
      currentRow: null,
    };
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.user);

    this.getNowTime();
    this.GetFoodDishList();
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      console.log(item);
      this.filters = {
        Name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    async editSubmit(formName) {
      if (this.foodJson.length != 0 && this.ruleForm.dishName != "") {
        let arr = this.foodJson.map((cc) => {
          return {
            foodId: cc.Id,
            foodName: cc.value,
            weight: cc.weight,
          };
        });
        const params = {
          Id: this.ruleForm.Id,
          dishName: this.ruleForm.dishName,
          list: arr,
        };
        let res = await UpdateHe_FoodDish(params);
        if (res.data.success) {
          this.$message({
            type: "success",
            message: res.data.msg,
          });
          this.$refs[formName].resetFields();
          this.resetData();
          this.dialogVisible = false;
          this.GetFoodDishList();
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      } else {
        this.$message({
          type: "error",
          message: "请选择或填写对应的选项",
        });
      }
    },
    // 编辑
    onClickEditData() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
          offset: 110,
        });

        return;
      }
      this.ruleForm = {
        Id: row.Id,
        dishName: row.DishName,
        ingredientValue: "",
        weight: "",
      };
      console.log(row, "row");
      this.foodJson = row.List.map((cc) => {
        return {
          value: cc.FoodName,
          weight: cc.Weight,
          FoodId: cc.FoodId,
          DishDetailId: cc.DishDetailId,
        };
      });
      this.dialogVisible = true;
    },
    // 删除
    async handledel() {
      let item = this.currentRow;
      if (!item) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
          offset: 110,
        });

        return;
      }
      this.$confirm("此操作将永久删除该菜肴, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await DelHe_FoodDish({ ids: [item.Id] });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.GetFoodDishList();
        } else {
          this.$message({
            type: "error",
            message: "删除失败!",
          });
        }
      });
    },
    resetData() {
      this.ruleForm = {
        Id: 0,
        dishName: "",
        ingredientValue: "",
        weight: "",
      };
      this.foodJson = [];
    },
    getData(val) {
      return JSON.parse(val);
    },
    onClickDelete(index) {
      this.foodJson.splice(index, 1);
    },
    onClickFood() {
      if (this.ruleForm.weight != "" && this.ruleForm.ingredientValue != "") {
        this.foodJson.push({
          Id: this.foodId,
          value: this.ruleForm.ingredientValue,
          weight: this.ruleForm.weight,
        });
        this.ruleForm.ingredientValue = "";
        this.ruleForm.weight = "";
      } else {
        this.$message({
          type: "error",
          message: "请填写重量或者食材",
        });
      }
    },
    handleSelect(item) {
      this.foodId = item.Id;
      this.ruleForm.ingredientValue = item.value;
    },
    async querySearchAsync(queryString, cb) {
      if (queryString != "") {
        let callBackArr = [];
        let res = await GetFoodLibrary();
        if (res.data.success) {
          this.isActive = true;
          res.data.response.forEach((item) => {
            if (item.Name.indexOf(queryString) > -1) {
              callBackArr.push({
                Id: item.Id,
                value: item.Name,
              });
            }
          });
          //console.log(callBackArr);
          if (callBackArr.length == 0) {
            this.isActive = false;
          } else {
            cb(callBackArr);
          }
        }
      }
    },
    // 新增
    async addSubmit(formName) {
      console.log(this.foodJson, "this.foodJson");

      if (this.foodJson.length != 0 && this.ruleForm.dishName != "") {
        let arr = this.foodJson.map((cc) => {
          return {
            foodId: cc.Id,
            foodName: cc.value,
            weight: cc.weight,
          };
        });
        const params = {
          dishName: this.ruleForm.dishName,
          list: arr,
        };
        let res = await AddHe_FoodDish(params);
        if (res.data.success) {
          this.$message({
            type: "success",
            message: res.data.msg,
          });
          this.$refs[formName].resetFields();
          this.resetData();
          this.dialogVisible = false;
          this.GetFoodDishList();
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      } else {
        this.$message({
          type: "error",
          message: "请选择或填写对应的选项",
        });
      }
    },
    // 重置
    resetSearch() {
      this.filters.Name = "";
      this.GetFoodDishList();
    },
    async GetFoodDishList(e) {
      console.log(this.filters.Name, "this.filters.Name");
      const params = {
        Name: this.filters.Name,
        Id: this.userInfo.SchoolId,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
      };
      let res = await GetFoodDishList(params);
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    //  新增本周食谱
    onAddFood() {
      this.Title = "新增菜肴";
      this.dialogVisible = true;
    },
    getNowTime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}-${date}`;
      this.$set(this.indexInfo, "date", defaultDate);
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetFoodDishList();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetFoodDishList();
    },
  },
};
</script>
<style lang="less" scoped>
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
.mg-right {
  margin-right: 20px;
}
.mg-bottom {
  margin-bottom: 10px;
}
.tui-food {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  text-align: center;
}
</style>